import { FunctionType } from '@/function';
import DataFactory from './DataFactory';

export default class FunctionWrapper {
    public wrap(fun: (args: any) => void, type: FunctionType) {
        if (type === 'form') {
            return this.wrapForm(fun);
        } else if (type === 'process') {
            return this.wrapProcess(fun);
        } else {
            return fun;
        }
    }

    private wrapForm(fun: (args: any) => void) {
        return (args: any) => {
            const dataService = args.form.dataService;
            const factory = new DataFactory(dataService.schema);

            const data = factory.create(dataService.data, args.form.define.form.archive.tableId);

            fun({ ...args, data });
        };
    }

    private wrapProcess(fun: (args: any) => void) {
        return (args: any) => {
            const dataService = args.process.dataService;
            const factory = new DataFactory(dataService.schema);

            const data = factory.create(dataService.data, args.process.define.archive.tableId);

            fun({ ...args, data });
        };
    }
}
